(function($){

	$(document).ready(function() {

		$('#mobilemenuModal').on('show.bs.modal',function(e){
			$('#site-header').addClass('mobileMenu-open');
			$('.mobile-triggers .menu-icon').addClass('mobileMenu-open');
			$('#mobilemenuModal').addClass('slide');
		});

		$('#mobilemenuModal').on('hide.bs.modal',function(e){
			$('.mobile-triggers .menu-icon').removeClass('mobileMenu-open');
			$('#mobilemenuModal').removeClass('slide');
		});

		$('#mobilemenuModal').on('hidden.bs.modal',function(e){
			$('#site-header').removeClass('mobileMenu-open');
		});

		$(document).on('click','#mobile-menu li.menu-item-has-children > a',function(e){
			e.preventDefault();
			$href = $(this).attr('href');

			if($href == '#') {
				$(this).parent().toggleClass('active');
				$(this).siblings('.sub-menu').slideToggle();
			} else {
				if(!$(this).parent().hasClass('active')) {
					$(this).parent().addClass('active');
					$(this).siblings('.sub-menu').slideDown();
				} else {
					window.location.href = $href;
				}
			}
		});

	});
	
})(jQuery);